import { FormLayout, Modal, ToggleSwitch } from '@therms/atalaya'
import React, { useState } from 'react'
import { useSessionStorage } from '@therms/react-modules'

interface DownloadRecordModalProps {
  closeHandler: () => void
  onDownload: (showComments: boolean) => void
}

function DownloadRecordModal({
  closeHandler,
  onDownload,
}: DownloadRecordModalProps) {
  const [sessionValue, setSessionValue] = useSessionStorage(
    'portalDownloadRecordOptions',
    { showComments: false },
  )
  const [showComments, setShowComments] = useState(
    sessionValue.showComments || false,
  )

  return (
    <Modal
      closeHandler={closeHandler}
      header="Download Record"
      outsideClickClose
      width="sm"
    >
      <FormLayout>
        <ToggleSwitch
          onChangeValue={(value) => {
            setShowComments(value)
            setSessionValue({ showComments: value })
          }}
          active={showComments}
          label="Would you like to include comments in the file?"
        />

        <FormLayout.Controls
          onSubmit={() => {
            onDownload(showComments)
          }}
          submitLabel="Download"
        />
      </FormLayout>
    </Modal>
  )
}

export { DownloadRecordModal }
